import type { BatchRow } from '@/generated/types/navigator/types.gen';

export type BatchGroup = {
  // null identifier represents the "No delivery" group
  deliveryIdentifier: string | null;
  batches: BatchRow[];
};

export const groupBatchesByDelivery = (batches: BatchRow[]): BatchGroup[] => {
  const deliveryGroups = new Map<string, BatchRow[]>();
  const noDelivery: BatchRow[] = [];

  for (const batch of batches) {
    const identifier = batch.delivery_identifier;
    if (identifier == null) {
      noDelivery.push(batch);
      continue;
    }
    const existing = deliveryGroups.get(identifier);
    if (existing) {
      existing.push(batch);
    } else {
      deliveryGroups.set(identifier, [batch]);
    }
  }

  const groups: BatchGroup[] = [...deliveryGroups.entries()]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([deliveryIdentifier, groupBatches]) => ({
      deliveryIdentifier,
      batches: groupBatches,
    }));

  if (noDelivery.length > 0) {
    groups.push({ deliveryIdentifier: null, batches: noDelivery });
  }

  return groups;
};

export const getDeliveryIdentifiers = (batches: BatchRow[]): string[] =>
  groupBatchesByDelivery(batches)
    .map((group) => group.deliveryIdentifier)
    .filter((identifier): identifier is string => identifier !== null)
    .sort((a, b) => a.localeCompare(b));
